/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// reactstrap components
import {
  Button,
  Modal,
  ModalBody,
  FormGroup,
  Input,
  Label
} from "reactstrap";
//redux components
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { 
  fetchAddUser,
  fetchGetValidationUserId
} from "../../actions/user_actions";

class UserRegisterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        userId: "",
        userFullName: "",
        userEmail: "",
        userIdState: "",
        userFullNameState: "",
        userEmailState: "",
        userId_isValidated: null,
    };
  }

  componentDidMount() {
    const {  } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
    if((user && prevProps.user && user.userId_validated && !prevProps.user.userId_validated) || 
        user && prevProps.user && user.userId_validated && prevProps.user.userId_validated && user.userId_validated !== prevProps.user.userId_validated) {
          if(user.userId_validated.result === true) {
            this.setState({userId_isValidated: true, userIdState: "has-success"});
          } else {
            this.setState({userId_isValidated: false, userIdState: "has-danger"});
          }
    }
  }

  verifyEmail = value => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };
  // function that verifies if a string has a given length or not
  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  verifyUserId = value => {
    this.setState({userId_isValidated: false})
    var emailRex = /^([a-z]+[0-9]*)+(-[a-z]+[0-9]*)*$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  change = (event, stateName, type, stateNameEqualTo) => {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "userId":
        if (this.verifyUserId(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger"});
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  handleIsAdmin = (event) => {
    this.setState({is_admin: event.target.checked});
  };

  handleValidateUserId = (ev) => {
    const { fetchGetValidationUserId } = this.props;
    const { userId } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let objUserIdValidation = {
      idToken: idToken,
      user_id: userId
    }
    fetchGetValidationUserId(objUserIdValidation);
  };

  saveUser = () => {
    const { 
      userFullName, 
      userEmail, 
      userId, 
      userFullNameState, 
      userEmailState, 
      userIdState, 
      is_admin 
    } = this.state
    const { fetchAddUser } = this.props;
    if (userFullNameState === "") {
      this.setState({ userFullNameState: "has-danger" });
    }
    if (userEmailState === "") {
      this.setState({ userEmailState: "has-danger" });
    }
    if (userIdState === "") {
      this.setState({ userIdState: "has-danger" });
    }
    if (this.state.userFullNameState !== "" && this.state.userEmailState !== "") {
      this.setState({
        addUser: !this.state.addUser,
        userFullName: "",
        userEmail: "",
        userFullNameState: "",
        userEmailState: "",
        userId: "",
        modalWatchUserData: false,
        newUser: true,
        userIdState: "",
        userId_isValidated: null
      });
    }

    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    
    let userObject = {
      token: idToken,
      email: userEmail,
      organization: userFullName,
      is_admin: is_admin,
      user_id: userId
    }
    fetchAddUser(userObject)
    this.props.handleAddUserModal();
  };

  render() {
    const { 
        userIdState, 
        userFullNameState, 
        userEmailState,
        userId,
        userFullName,
        userEmail,
        userId_isValidated
    } = this.state;
    const { addUser, handleAddUserModal } = this.props;
    // console.log(user);
    return (
      <>
        <Modal
            isOpen={addUser}
            toggle={handleAddUserModal}
            size="lg"
        >
            <div className="modal-header" style={{justifyContent: 'center'}}>
                <h4 className="title title-up">
                    User Register
                </h4>
            </div>
            <ModalBody>
                <FormGroup className={`has-label ${userEmailState}`}>
                    <label>Email Address *</label>
                    <Input
                        name="email"
                        type="email"
                        onChange={e => this.change(e, "userEmail", "email")}
                        style={{color: "#000"}}
                    />
                    {userEmailState === "has-danger" ? (
                        <label className="error">
                        Please enter a valid email address.
                        </label>
                    ) : null}
                </FormGroup>
                <FormGroup className={`has-label ${userFullNameState}`}>
                    <label>Organization *</label>
                    <Input
                        name="fullname"
                        type="text"
                        onChange={e =>
                        this.change(e, "userFullName", "length", 1)
                        }
                        style={{color: "#000"}}
                    />
                    {userFullNameState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                    ) : null}
                </FormGroup>
                <FormGroup className={`has-label ${userIdState}`} >
                    <label>User Id *</label>
                    <div>
                        <Input
                            name="userId"
                            type="text"
                            onChange={e =>
                            this.change(e, "userId", "userId", 1)
                            }
                            style={{display: "inline-block", color: "#000", minWidth: "73%"}}
                        />
                        <Button 
                            type="button"
                            onClick={this.handleValidateUserId}
                            color="default"
                            style={{display: "inline-block", /*marginLeft: "10px"*/}}
                            disabled={userIdState !== "has-danger" && userIdState !== "" ? false : true}
                        >
                            Validate User Id
                        </Button>
                    </div>
                    {userIdState === "has-danger" ? (
                    <label className="error">This User Id has not a validate format or is not verified.</label>
                    ) : null}
                    {userId_isValidated ? (
                    <label className="success">User Id validated.</label>
                    ) : null}
                </FormGroup>
                <FormGroup check className="pull-left">
                    <Label check>
                        <Input name="optionCheckboxes" type="checkbox" onClick={this.handleIsAdmin}/>
                        <span className="form-check-sign" />
                        User is Admin
                    </Label>
                </FormGroup>
            </ModalBody>
            <div className="modal-footer justify-content-center">
                <Button
                    className="btn-round"
                    color="info"
                    data-dismiss="modal"
                    type="button"
                    onClick={this.saveUser}
                    disabled={
                        userFullName === "" || 
                        userEmail === "" || 
                        userId === "" || 
                        userEmailState === "has-danger" || 
                        userFullNameState === "has-danger" || 
                        userIdState === "has-danger" || 
                        userId_isValidated === false ? true : false
                    }
                >
                    Save New User
                </Button>
            </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchAddUser, fetchGetValidationUserId }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegisterModal);